import { render, staticRenderFns } from "./mock-text-conversation.vue?vue&type=template&id=482dca54&scoped=true&"
import script from "./mock-text-conversation.vue?vue&type=script&lang=js&"
export * from "./mock-text-conversation.vue?vue&type=script&lang=js&"
import style0 from "./mock-text-conversation.vue?vue&type=style&index=0&id=482dca54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482dca54",
  null
  
)

export default component.exports